import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=202642f0&scoped=true&"
import script from "./FormPassword.vue?vue&type=script&lang=tsx&"
export * from "./FormPassword.vue?vue&type=script&lang=tsx&"
import style0 from "./FormPassword.vue?vue&type=style&index=0&id=202642f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202642f0",
  null
  
)

export default component.exports